<template>
  <BittsLink
    class="learn-more-link"
    :text="text"
    :url="url"
    :open-in-new-tab="true"
    @click="handleClick"
  />
</template>

<script setup lang="ts">
import { BittsLink } from '@crossbeam/bitts';
import type { EventSiteType } from '@crossbeam/itly';

import useIteratively from '@/composables/useIteratively';

const { text, url, eventSite } = defineProps<{
  text: string;
  url: string;
  eventSite: EventSiteType;
}>();

const { iteratively } = useIteratively();

function handleClick() {
  iteratively.userClickedLearnMore({ event_site: eventSite });
}
</script>
